import Axios from "axios";

export interface IWings {
  metadata: object;
  GLAccount: string;
  AccountGroup: string;
  DeletionFlag: boolean;
  BlockedForCreation: boolean;
  BlockedForPosting: boolean;
  BlockedForPlanning: boolean;
  ChartOfAccts: string;
  CompanyCode: string;
  AcctCurrency: string;
  ShortText: string;
  LongText: string;
}

interface ILines {
  date: string;
  end_date: string;
  gl_account: string;
}

export async function getGlAccounts(filter: string, signal?: AbortSignal) {
  const response = await Axios.get<IWings[]>("/api/wings/glaccount/", {
    params: { filter },
    signal,
  });
  return response.data;
}

export async function getMatchingLines(data: ILines) {
  try {
    const response = await Axios.get(`/api/wings/glaccount/${data.gl_account}/lineitems/`, {
      params: {
        date_from: data.date,
        date_to: data.end_date,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
